module.exports = __webpack_public_path__ + "img/hero-image-landing-3.861d0c50.png";